/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadCareAttributes200ResponseDataInner
 */
export interface UpdateLeadCareAttributes200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadCareAttributes200ResponseDataInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadCareAttributes200ResponseDataInner
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadCareAttributes200ResponseDataInner
     */
    care_attribute_id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadCareAttributes200ResponseDataInner
     */
    category: UpdateLeadCareAttributes200ResponseDataInnerCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadCareAttributes200ResponseDataInner
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadCareAttributes200ResponseDataInner
     */
    created_by_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadCareAttributes200ResponseDataInner
     */
    created_at: string;
}


/**
 * @export
 */
export const UpdateLeadCareAttributes200ResponseDataInnerCategoryEnum = {
    ClinicalCareNeed: 'clinical_care_need',
    Program: 'program',
    TypeOfCare: 'type_of_care'
} as const;
export type UpdateLeadCareAttributes200ResponseDataInnerCategoryEnum = typeof UpdateLeadCareAttributes200ResponseDataInnerCategoryEnum[keyof typeof UpdateLeadCareAttributes200ResponseDataInnerCategoryEnum];


/**
 * Check if a given object implements the UpdateLeadCareAttributes200ResponseDataInner interface.
 */
export function instanceOfUpdateLeadCareAttributes200ResponseDataInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "care_attribute_id" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "created_by_user_id" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function UpdateLeadCareAttributes200ResponseDataInnerFromJSON(json: any): UpdateLeadCareAttributes200ResponseDataInner {
    return UpdateLeadCareAttributes200ResponseDataInnerFromJSONTyped(json, false);
}

export function UpdateLeadCareAttributes200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadCareAttributes200ResponseDataInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'care_attribute_id': json['care_attribute_id'],
        'category': json['category'],
        'label': json['label'],
        'created_by_user_id': json['created_by_user_id'],
        'created_at': json['created_at'],
    };
}

export function UpdateLeadCareAttributes200ResponseDataInnerToJSON(value?: UpdateLeadCareAttributes200ResponseDataInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'care_attribute_id': value.care_attribute_id,
        'category': value.category,
        'label': value.label,
        'created_by_user_id': value.created_by_user_id,
        'created_at': value.created_at,
    };
}

